const Environment = {
    host: 'https://server.trippyasia.com/public/api',
    // host: 'http://localhost:3001/public/api',
};
export default Environment;
